import { render, staticRenderFns } from "./AssessorFeedbackDocument.vue?vue&type=template&id=13164247&"
import script from "./AssessorFeedbackDocument.vue?vue&type=script&lang=js&"
export * from "./AssessorFeedbackDocument.vue?vue&type=script&lang=js&"
import style0 from "./AssessorFeedbackDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports